import { gql } from "@apollo/client";

export const getLensStudioVersions = gql`
    query getLensStudioVersions {
        getLensStudioVersions {
            versions {
                label
                value {
                    major
                    minor
                    patch
                }
            }
        }
    }
`;
